import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'

import { Center, Spinner } from '@masterplandev/ui'

import { FEATURE_DASHBOARD_LEARNPATH } from '@/core/constants/features'
import useScormConfiguration from '@/scorm/hooks/useScormConfiguration'

export const Route = createFileRoute('/_learning/_company/_list')({
  beforeLoad: async ({ context }) => {
    if (!context.user?.features.includes(FEATURE_DASHBOARD_LEARNPATH)) {
      throw redirect({ to: '/home' })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { learnpathId, learnpath_external_id } = useScormConfiguration()

  // We wait and show spinner until learnpathId is available in SCORM view
  if (learnpath_external_id && !learnpathId) {
    return (
      <Center py={14}>
        <Spinner size="xl" />
      </Center>
    )
  }

  return <Outlet />
}
